
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.2 14.3c-.7 0-1.4.3-1.9.8L15 13.7c.1-.4.2-.8.2-1.2 0-2-1.5-3.7-3.4-4.1V4.9c.4-.1.7-.3 1-.6.5-.5.7-1.1.7-1.8C13.5 1.1 12.4 0 11 0S8.5 1.1 8.5 2.5c0 1.1.7 2.1 1.8 2.4v3.6c-1.9.4-3.4 2-3.4 4.1 0 .3.1.7.1 1L4.6 15c-.5-.4-1.1-.7-1.8-.7-1.5 0-2.8 1.3-2.8 2.8C0 18.7 1.3 20 2.8 20s2.8-1.3 2.8-2.8c0-.3-.1-.6-.2-.9L7.6 15c.7 1.1 2 1.8 3.4 1.8 1.3 0 2.5-.6 3.3-1.6l2.3 1.3c-.1.2-.1.5-.1.7 0 1.5 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8c-.1-1.6-1.4-2.9-2.9-2.9zM2.8 18.5c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3s1.3.6 1.3 1.3c0 .7-.6 1.3-1.3 1.3zm8.2-17c.6 0 1 .5 1 1 0 .3-.1.5-.3.7-.2.2-.4.3-.7.3-.6 0-1-.5-1-1s.4-1 1-1zm9.5 15.7c0 .7-.6 1.3-1.3 1.3s-1.3-.6-1.3-1.3c0-.7.6-1.3 1.3-1.3.7-.1 1.3.5 1.3 1.3z","fill":"#5686f6"}})])
          )
        }
      }
    